const $ = require('jquery');

window.pressroomRecaptchaOnloadCallback = function () {
    grecaptcha.render('pressroom_recaptcha', {
        'sitekey': '6LebJ4EUAAAAAEiDQBOYhcrufhtMKdlcMNBma6ln',

        'callback': function (response) {
            $('#modal-download-files button').removeAttr('disabled').removeClass('btn-disabled').addClass('btn-primary');
        }
    });
};

jQuery(document).ready(function () {

    function setDownloadButtonClass($rootElement) {

        if (typeof $rootElement === 'undefined') {
            // No can do, sir
            return;
        }

        var selectedFileCount = $rootElement.find('.download.download--selected').length,
            downloadButton = $rootElement.find('.download-files'),
            downloadCounter = downloadButton.find('.count'),
            buttonClassDisabled = 'btn-disabled',
            buttonClassActive = 'btn-primary';

        if (selectedFileCount > 0) {
            if (downloadButton.hasClass(buttonClassDisabled)) {
                downloadButton.removeClass(buttonClassDisabled).addClass(buttonClassActive);
            }
        } else {
            if (!downloadButton.hasClass(buttonClassDisabled)) {
                downloadButton.removeClass(buttonClassActive).addClass(buttonClassDisabled);
            }
        }

        downloadCounter.html('(' + selectedFileCount + ')');
    }

    $('.pressroom').each(function () {

        var $root = $(this);

        // pressroom download toggles
        $root.find('.download').click(function (e) {
            e.preventDefault();

            if ($(this).hasClass('download--selected')) {
                $(this).removeClass('download--selected');
            } else {
                $(this).addClass('download--selected');
            }

            setDownloadButtonClass($root);
        });

        // pressroom download files
        $('#modal-download-files form').submit(function (e) {
            e.preventDefault();
            var buttonClassDisabled = 'btn-disabled';
            var submitBtn = $(this).find('button');

            if (!submitBtn.hasClass(buttonClassDisabled)) {
                submitBtn.addClass('btn-disabled').removeClass('btn-primary').prepend('<i class="fa-left fa-spin fa fa-spinner"></i>');
                // Gather the ids to download
                var download_ids = [];
                $root.find('.pressroom__grid .download--selected').each(function () {
                    download_ids.push($(this).data('file-id'));
                });

                var pressroom_id = $root.data('pressroom-id');

                $.post(
                    '/wp-json/dbk-westcord-hotels/pressroom/download',
                    {
                        ids: download_ids,
                        pressroom_id: pressroom_id,
                        download_company: $('#modal-download-files input[name=download_company]').val(),
                        download_name: $('#modal-download-files input[name=download_name]').val(),
                        download_email: $('#modal-download-files input[name=download_email]').val(),
                        download_use: $('#modal-download-files input[name=download_use]').val(),
                        download_send_example: $('#modal-download-files input[name=download_send_example]').val()
                    },
                    function (data) {
                        if ('string' === typeof data) {

                            window.location = data;
                        }

                        submitBtn.removeClass('btn-disabled').addClass('btn-primary').find('i').remove();
                        $('#modal-download-files .close-modal').click();
                    }
                );
            }
            return false;
        });

        setDownloadButtonClass($root);

        // pressroom filters
        $root.find('.pressroom__filters .filter__button').click(function (e) {
            e.preventDefault();

            var $loader = $root.find('.pressroom__grid .loader');
            var filter_types = $(this).data('filter-type');

            $(this).closest('.filter').addClass('filter--active').siblings().removeClass('filter--active');

            // loader demo
            $loader.addClass('loader--visible');
            setTimeout(function () {

                if ('' === filter_types) {
                    $root.find('.flex-item').show();
                } else {
                    $root.find('.flex-item').hide();
                    var filter_types_arr = filter_types.split(',');

                    for (var i in filter_types_arr) {
                        $root.find('.flex-item[data-file-type="' + filter_types_arr[i] + '"]').show();
                    }
                }

                $loader.removeClass('loader--visible');
            }, 500);
        });

        if (0 === $root.find(
            '.flex-item[data-file-type="jpg"], ' +
            '.flex-item[data-file-type="png"], ' +
            '.flex-item[data-file-type="eps"]'
        ).length) {
            $root.find('.filter__button[data-filter-type="jpg,eps,png"]').hide();
        }

        if (0 === $root.find('.flex-item[data-file-type="pdf"]').length) {
            $root.find('.filter__button[data-filter-type="pdf"]').hide();
        }

        // If there's only one filter ("All" plus one filter), than hide the filter buttons
        if (2 === $root.find('.filter__button:visible').length) {
            $root.find('.pressroom__filters').hide();
        }
    });


});